import { render } from "./BookingSummary.vue?vue&type=template&id=57ef45d0&scoped=true"
import script from "./BookingSummary.vue?vue&type=script&lang=js"
export * from "./BookingSummary.vue?vue&type=script&lang=js"

import "./BookingSummary.vue?vue&type=style&index=0&id=57ef45d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ef45d0"]])

export default __exports__